
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarNorth as ObiBuoyPilarNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-north.js';
 
 
 

 
 export const ObiBuoyPilarNorth = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-north',
   elementClass: ObiBuoyPilarNorthElement,
   events: {
     
   }
  });
 
 